export default {
  discount_badge: '{{value}} zniżki',
  high_caffeine_warning_required: 'Wysoka zawartość kofeiny',
  pfand: 'W tym kaucja {{value}}',
  alcohol_by_volume_percent: '{{value}} % obj. alkoholu',
};
